import React from "react";
import { Link } from "react-router-dom";
import { navigationItems } from "./Navigation";

const Footer = () => {
  return (
    <footer className="w-full bg-[#111111] border-t border-white/10 py-8">
      <div className="max-w-7xl mx-auto px-4 flex flex-col md:flex-row items-center justify-between gap-6">
        {/* Navigation Links */}
        <nav className="flex flex-wrap gap-6 justify-center md:justify-start mb-4 md:mb-0">
          {navigationItems.map((item) => (
            <Link
              key={item}
              to={`/${item.toLowerCase().replace(/\s+/g, "-")}`}
              className="text-white/80 hover:text-primary-green font-medium transition-colors"
            >
              {item}
            </Link>
          ))}
          <Link
            to="/privacy-policy"
            className="text-white/80 hover:text-primary-green font-medium transition-colors"
          >
            Privacy Policy
          </Link>
        </nav>
        {/* Copyright */}
        <div className="text-white/50 text-sm text-center md:text-right">
          © Hear Me Out Music Co. {new Date().getFullYear()}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
